export default "__VITE_ASSET__Xyha8wAw__";